import { ContentsLayoutProps } from 'src/components/layout/ContentsLayout/index'
import styled from 'styled-components'
import { fadeTransitionProps } from 'src/styles/animation'
import { useNavigationType } from 'react-router-dom'
import { useChannel } from 'src/provider/ChannelContextProvider'

// display:none 전환 시 Swiper 등 자식이 너비 0으로 초기화되는 것을 방지
const pageFadeVariants = {
  initial: { opacity: 0, pointerEvents: 'none' as const },
  in: { opacity: 1, pointerEvents: 'auto' as const },
  out: { opacity: 0, pointerEvents: 'none' as const },
}

const ContentsLayoutView = ({ children }: ContentsLayoutProps) => {
  const { ios } = useChannel()
  const navigationType = useNavigationType()
  return (
    <ContentsLayoutWrap
      {...(!ios &&
        navigationType !== 'POP' && {
          ...fadeTransitionProps,
          variants: pageFadeVariants,
        })}
    >
      {children}
    </ContentsLayoutWrap>
  )
}
export default ContentsLayoutView

const ContentsLayoutWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  flex: 1;
  height: 100%;
`
